module.exports = __webpack_public_path__ + "static/media/product-2.f87d1168.png";